var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'active' : _vm.active}},[_vm._t("trigger",null,{"active":_vm.active,"handleCollapse":_vm.handleCollapse}),_vm._t("content",null,{"active":_vm.active,"handleParentAction":_vm.handleParentAction})],2)}
var staticRenderFns = []

export { render, staticRenderFns }